import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(Button)(({ color = '#6ac700' }) => ({
    ':hover': {
        backgroundColor: '#4fa300',
        color: 'white'
    },
    backgroundColor: '#6ac700',
    color: 'white'
}));